export const ROLES = [
  // { id: 'read-only', label: 'Read Only' },
  { id: 'editor', label: 'Editor' },
  { id: 'super-user', label: 'Super User' },
];
